<template>
  <v-container class="home fill-height pa-2">
    <list-of-projects />
    <guidance-button page="dashboard" />
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import ListOfProjects from "../components/ListOfProjects";
import GuidanceButton from "@/components/guidance/GuidanceButton";

export default {
  name: "home",
  data: () => ({
    isLoading: false,
  }),
  components: {
    ListOfProjects,
    GuidanceButton,
  },
  methods: {
    ...mapMutations("projectsStore", ["resetProjectsState"]),
    ...mapMutations("projectStore", ["resetProjectState"]),
    ...mapMutations("buildingStore", ["resetBuildingState"]),
    ...mapMutations("floorStore", ["resetFloorState"]),
    ...mapMutations("roomStore", ["resetRoomState"]),
    ...mapMutations("loaderStore", ["setIsLoading"]),
    ...mapActions("projectsStore", ["getAllProjects"]),
    ...mapActions("projectStore", ["getMaintenanceFlag"]),
    ...mapActions("companyInfoStore", ["getCompanyInfo"]),
    async initialize() {
      this.resetProjectsState();
      this.resetProjectState();
      this.resetBuildingState();
      this.resetFloorState();
      this.resetRoomState();
      await this.getAllProjects();
      await this.getMaintenanceFlag();
      await this.getCompanyInfo();
    },
  },
  created() {
    this.setIsLoading(true);
    this.initialize().then(() => {
      this.setIsLoading(false);
    });
  },
};
</script>

<style lang="scss">
#nikoApp {
  .home {
    width: 100%;
  }
}
</style>
